import Vue from "vue";
import Vuetify from "vuetify";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdiSvg"
  },
  theme: {
    dark: false,
    themes: {
      dark: {
        primary: "#23A0A0",
        secondary: "#b0bec5",
        accent: "#FF6B6B",
        error: "#b71c1c",
        orange: "#FF6B6B",
        purple: "#647FF7",
        "dark-blue": "#152B5E",
        "dark-grey": "#AAAAAA"
      },
      light: {
        primary: "#23A0A0",
        secondary: "#FFE24D",
        accent: "#FF6B6B",
        error: "#b71c1c",
        background: "#F6F8FA",
        orange: "#FF6B6B",
        purple: "#647FF7",
        "dark-blue": "#152B5E",
        "dark-grey": "#AAAAAA"
      }
    }
  }
});
